import { Span } from "../../../../base/components/native/span"
import { nameTdStyle } from "./name-td.style"
import { RateTd } from "./rate-td"

export const NameTd = (title: string) => {
    const base = RateTd()
    base.append(Span(title))

    base.cssClass(nameTdStyle)

    return base
}